var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeBreak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.39 -67.135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.176,96.787h-5.5V88.437h1.5v6.851h4Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.485,84.653c-.363-.008-.413.286-.281.65a3.764,3.764,0,0,1-.391,2.742,3.76,3.76,0,0,0-.389,2.7,1.269,1.269,0,0,0,1.044.668h.009c.366,0,.4-.29.27-.647a3.75,3.75,0,0,1,.387-2.731,3.778,3.778,0,0,0,.4-2.714A1.268,1.268,0,0,0,14.485,84.653Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.927,84.653c-.363-.008-.413.286-.281.65a3.764,3.764,0,0,1-.391,2.742,3.755,3.755,0,0,0-.39,2.7,1.269,1.269,0,0,0,1.044.668h.009c.361,0,.4-.29.272-.647a3.745,3.745,0,0,1,.387-2.731,3.782,3.782,0,0,0,.394-2.714A1.268,1.268,0,0,0,11.927,84.653Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.089,85.321a1.268,1.268,0,0,0-1.044-.668c-.363-.008-.413.286-.281.65a3.764,3.764,0,0,1-.391,2.742,3.766,3.766,0,0,0-.39,2.7,1.269,1.269,0,0,0,1.044.668h.009c.361,0,.4-.29.271-.647a3.745,3.745,0,0,1,.387-2.731A3.778,3.778,0,0,0,18.089,85.321Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2,99.672a3.28,3.28,0,0,0-1.5-2.526,5.015,5.015,0,0,0-3.972-.408c.053-.8.091-1.608.106-2.442l.031-1.732-28.479,0,.03,1.727a43.13,43.13,0,0,0,.98,8.643c.079.343.161.682.246,1.022s.188.688.285,1.016c.263.887.564,1.749.9,2.565.144.354.294.69.446,1.032s.331.692.489.989a15.518,15.518,0,0,0,3.2,4.344l.1.077a2.517,2.517,0,0,0,1.339.43H22.9a2.542,2.542,0,0,0,1.377-.483l.1-.088a12.622,12.622,0,0,0,1.4-1.562,18.779,18.779,0,0,0,1.768-2.819c.184-.355.351-.73.519-1.1l.057-.022a20.168,20.168,0,0,0,5.548-3.412l.029-.026C35.483,103.185,36.37,101.323,36.2,99.672ZM24.591,111.365a11.166,11.166,0,0,1-1.219,1.363.994.994,0,0,1-.5.177H10.423a1,1,0,0,1-.477-.141,14.118,14.118,0,0,1-2.851-3.895c-.154-.292-.308-.605-.458-.926s-.284-.638-.421-.976c-.313-.769-.6-1.586-.847-2.426-.094-.313-.184-.636-.27-.963s-.161-.651-.235-.976a41.509,41.509,0,0,1-.944-8.336l0-.206,25.426,0,0,.2c-.1,5.815-1.152,10.692-3.118,14.5A17.257,17.257,0,0,1,24.591,111.365Zm8.09-7.572a18.579,18.579,0,0,1-3.515,2.4A34.8,34.8,0,0,0,30.81,98.3a3.491,3.491,0,0,1,3.113.126A1.772,1.772,0,0,1,34.71,99.8C34.83,101,34.11,102.419,32.681,103.793Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.446,107.99a12.055,12.055,0,0,1-5.995-1.6l.744-1.3a10.533,10.533,0,1,0-3.012-15.709l-1.173-.935a12.035,12.035,0,1,1,9.436,19.552Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.658,112.946a16.8,16.8,0,0,1-8.6-2.365c-.173-.1-.345-.208-.515-.317L32.353,109q.232.15.469.29a15.41,15.41,0,1,0-5.389-21.115l-1.289-.766a16.909,16.909,0,1,1,14.514,25.535Z",
    fill: "#1d1d1b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBreak);
export default __webpack_public_path__ + "static/media/time_break.9ed2d9a29b6b8fbe0b6e838ede96a984.svg";
export { ForwardRef as ReactComponent };